// Build-time feature flags.
//
// Create React App inlines process.env.REACT_APP_* at BUILD time, so these are
// resolved per environment when the bundle is built - not at runtime. The
// deploy scripts write the values into .env.production before `npm run build`.
//
// Default is ENABLED: a missing value must not silently disable a feature in
// local development. Only the explicit string 'false' turns it off.

export const INTEGRATION_BUILDER_ENABLED =
  process.env.REACT_APP_ENABLE_INTEGRATION_BUILDER !== 'false';
